// extracted by mini-css-extract-plugin
export default {"root":"JWgJp","header":"_wpbl","body":"_ry6Y","divider":"lPVGZ","close":"_KIZe"};